import { render, staticRenderFns } from "./marketingList.vue?vue&type=template&id=470b996e&scoped=true&"
import script from "./marketingList.vue?vue&type=script&lang=js&"
export * from "./marketingList.vue?vue&type=script&lang=js&"
import style0 from "./marketingList.vue?vue&type=style&index=0&id=470b996e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b996e",
  null
  
)

export default component.exports